import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationProfile } from '@app/@shared/models/application-profile.model';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { AuthenticationService } from '@app/auth';
import { FONT_AWESOME_ICONS } from '@ep/shared';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MenuItem } from 'primeng/api';

@UntilDestroy()
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() closeClicked = new EventEmitter<void>();

  items!: MenuItem[];
  applicationProfile!: ApplicationProfile;
  fullUserName!: string;
  isMobileScreen: boolean = false;
  icons = FONT_AWESOME_ICONS;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private applicationProfileService: ApplicationProfileService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileScreen = window.innerWidth <= 550;
  }

  ngOnInit() {
    this.onResize({});

    this.items = [
      {
        label: 'Change Password',
        icon: 'pi pi-user-edit',
        command: () => {
          this.onChangePasswordClicked();
        },
      },
      {
        label: 'Log Out',
        icon: 'pi pi-sign-out',
        command: () => {
          this.onLogoutClicked();
        },
      },
    ];

    this.applicationProfileService.applicationProfile$
      .pipe(untilDestroyed(this))
      .subscribe((applicationProfile: ApplicationProfile) => {
        this.applicationProfile = applicationProfile;
        this.fullUserName = `${this.applicationProfile.Representative.NameFirst} ${this.applicationProfile.Representative.NameLast}`;
      });
  }

  onLogoutClicked(): void {
    this.authenticationService.logout().subscribe(() => this.router.navigate(['/auth/login'], { replaceUrl: true }));
  }

  onChangePasswordClicked(): void {
    this.router.navigate([`${this.applicationProfile.Representative.CoalitionId}/change-password`]);
  }

  onCloseClicked(event?: any): void {
    this.closeClicked.emit(event);
  }
}
